import { c as _c } from "react/compiler-runtime";
import { Text } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { DataGridPro } from "@mui/x-data-grid-pro";
const DATA_GRID_SX = {
  // MUI truncates cells to one line, but the descriptions need to wrap
  "& .MuiDataGrid-cell": {
    whiteSpace: "normal",
    py: 1
  }
};
/**
 * @returns The columns of a dev features table: name, description and the item's control
 */
function getColumns(renderControl) {
  return [{
    field: "name",
    headerName: "Name",
    flex: 1,
    minWidth: 140,
    display: "flex",
    renderCell: ({
      row
    }) => <Text variant="heading12">{row.item.label}</Text>
  }, {
    field: "description",
    headerName: "Description",
    flex: 2,
    minWidth: 200,
    display: "flex",
    renderCell: ({
      row
    }) => <Text variant="helpText">{row.item.description}</Text>
  }, {
    field: "control",
    headerName: "",
    flex: 1,
    minWidth: 240,
    align: "right",
    display: "flex",
    renderCell: ({
      row
    }) => renderControl(row.item)
  }];
}

/**
 * Render a table component for the development features or tools.
 */
export function DevFeaturesTable(t0) {
  const $ = _c(13);
  const {
    title,
    items,
    renderControl
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const rows = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      mb: 1
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = <Text variant="heading16" sx={t2}>{title}</Text>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== renderControl) {
    t4 = getColumns(renderControl);
    $[5] = renderControl;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== rows || $[8] !== t4) {
    t5 = <DataGridPro rows={rows} columns={t4} autoHeight={true} getRowHeight={_temp2} hideFooter={true} disableColumnMenu={true} disableColumnSorting={true} disableColumnReorder={true} disableColumnResize={true} disableRowSelectionOnClick={true} sx={DATA_GRID_SX} />;
    $[7] = rows;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <Box>{t3}{t5}</Box>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp2() {
  return "auto";
}
function _temp(item) {
  return {
    id: item.label,
    item
  };
}